import { defineMessages } from 'react-intl';

export default defineMessages({
    discounts: {
        id: 'policycommon.component.vehicle-discountSurcharge.Name',
        defaultMessage: 'Discounts'
    }
});
